import type { RefObject } from 'react';
import type { DropdownOption } from '../text-dropdown';

export interface ScrollToDropdownItemOptions {
  dropdownRef: RefObject<HTMLDivElement>;
  options: DropdownOption[];
  targetValue: string;
  behavior?: ScrollBehavior;
}

function scrollToItem(
  dropdownElement: HTMLElement,
  item: HTMLElement,
  behavior: ScrollBehavior
) {
  const dropdownHeight = dropdownElement.clientHeight;
  const itemTop = item.offsetTop;
  const itemHeight = item.offsetHeight;
  const scrollPosition = itemTop - dropdownHeight / 2 + itemHeight / 2;

  if (behavior === 'auto') {
    dropdownElement.scrollTop = Math.max(0, scrollPosition);
  } else {
    dropdownElement.scrollTo({
      top: Math.max(0, scrollPosition),
      behavior
    });
  }
}

export function scrollToDropdownItem({
  dropdownRef,
  options,
  targetValue,
  behavior = 'smooth'
}: ScrollToDropdownItemOptions) {
  const dropdownElement = dropdownRef.current;

  if (!dropdownElement) {
    return;
  }

  const targetIndex = options.findIndex((opt) => opt.value === targetValue);

  if (targetIndex === -1) {
    return;
  }

  const allItems = Array.from(dropdownElement.children) as HTMLElement[];

  const targetItem = allItems[targetIndex];

  if (targetItem) {
    scrollToItem(dropdownElement, targetItem, behavior);
  }
}
